import { Page } from '@/components';
import BorrowWalletsTable from './BorrowWalletsTable';
import { Flex, TextSearchFilter, useTableProps } from '@blockanalitica/ui';
import HistoricGraphs from './HistoricGraphs';

export default function BorrowersWalletsPage() {
  const { filters } = useTableProps({
    filtersDebounceTime: 500,
    initialFilters: {
      textSearch: ''
    }
  });

  return (
    <Page title="Borrower Wallets">
      <HistoricGraphs />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSearchFilter placeholder="Search by address" {...filters} />
      </Flex>
      <BorrowWalletsTable search={filters.filtersApplied['textSearch']} />
    </Page>
  );
}
